import { useSelector } from 'react-redux';

export const useCanChangePaymentState = () =>
  useSelector((state) => state.authentication.userInfo.CanChangePaymentState);
